module.exports = __webpack_public_path__ + "img/systemBidFlow.8c43c4c8.gif";